import commonTrashListCreateOrEditWithAgGrid
  from '@/views/modules/_mixins/commonTrashListCreateOrEditWithAgGrid';

/**
 * mixins for template list with trash and ag grid
 *
 * @module src/views/modules/templates/mixins/commonTemplateListCreateOrEdit.js
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-data {Function | null} sendCampaignFromTemplateFunction - function to call on send campaign
 * @vue-computed {Object[]} [additionalActionsOnList=[]] - additional actions on list
 * @vue-computed {Object[]} additionalActionsOnListForTemplate -
 * additional list actions for templates
 * @vue-event {void} onActionFromCreateOrEditForTemplate -
 * called on action to make it from create or edit
 * @vue-event {void} onSendCampaignFromCreateOrEdit -
 * called form create or edit to send one campaign
 */
export default {
  mixins: [commonTrashListCreateOrEditWithAgGrid],
  data() {
    return {
      sendCampaignFromTemplateFunction: () => {},
    };
  },
  computed: {
    additionalActionsOnList() {
      return this.additionalActionsOnListForTemplate;
    },
    additionalActionsOnListForTemplate() {
      return [
        {
          name: 'send',
          color: 'success',
          text: '$General.SendCampaign',
          position: 'top',
          icon: 'icon-send',
          iconVue: 'SendIcon',
          activeCreateOrEdit: this.operation === this.$enums.Operation.VIEW
            || this.operation === this.$enums.Operation.EDIT,
          active: !this.trash,
        },
        ...this.additionalActionsOnListForTrash,
      ];
    },
  },
  methods: {
    onActionFromCreateOrEditForTemplate(action) {
      switch (action) {
        case 'send':
          this.onSendCampaignFromCreateOrEdit(this.recordSelected);
          break;

        default:
          this.onActionFromCreateOrEditForTrash(action);
      }
    },
    async onSendCampaignFromCreateOrEdit(payload) {
      this.dontConfirmCloseCreateOrEdit = true;
      this.activeModalCreateOrEdit = false;

      const confirmed = await this.confirmCloseCreateOrEditModal();

      if (confirmed) {
        this.showCreateOrEditComponent = false;
        this.sendCampaignFromTemplateFunction(payload);
      } else {
        this.activeModalCreateOrEdit = true;
      }

      this.dontConfirmCloseCreateOrEdit = false;
    },
  },
};
